import React from 'react'
import InviteBotButton from './InviteBotButton'
import './Installation.css'

function Installation() {
  const steps = [
    { num: 1, text: 'Ajoute le bot sur ton serveur Discord' },
    { num: 2, text: 'Lance la commande !install' },
    { num: 3, text: 'Le bot fait l\'installation tout seul. C\'est tout !' }
  ]

  return (
    <section id="installation" className="installation" aria-labelledby="installation-title">
      <header>
        <h2 id="installation-title" className="section-title">Installation</h2>
        <p className="section-subtitle">
          En quelques minutes, Pokéfarm est opérationnel sur ton serveur
        </p>
      </header>
      <ol className="installation-steps" role="list">
        {steps.map((step) => (
          <li key={step.num} className="installation-step" role="listitem">
            <span className="installation-step-num" aria-hidden="true">{step.num}</span>
            <span className="installation-step-text">{step.text}</span>
          </li>
        ))}
      </ol>
      <div className="installation-cta">
        <InviteBotButton className="btn-install">
          Ajouter le bot
        </InviteBotButton>
      </div>
    </section>
  )
}

export default Installation
